import usePageTitle from "@entrilia/shared/hooks/usePageTitle";
import useClientContext from "./useClientContext";

const useClientPageTitle = (pageName: string) => {
  const { clientTitle } = useClientContext();

  usePageTitle(pageName, { customAppPageTitle: `${clientTitle} Investor Portal` });

  return clientTitle;
};

export default useClientPageTitle;
